import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { Monogram } from "@/components/site/Logo";
import { Input } from "@/components/site/Form";
import { apiError } from "@/lib/api";
import { useAuth } from "./auth";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { await login(email, password); nav(loc.state?.from || "/admin", { replace: true }); }
    catch (x) { setErr(apiError(x)); } finally { setBusy(false); }
  };
  return (
    <main className="grid min-h-screen place-items-center bg-stone/40 px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm border border-stone bg-paper p-8" data-testid="admin-login-form">
        <Monogram className="h-12 w-12" />
        <h1 className="mt-6 font-serif text-4xl">Admin sign in</h1>
        <div className="mt-8 space-y-5">
          <Input id="admin-email" label="Email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <Input id="admin-password" label="Password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          {err && <p role="alert" className="text-sm text-[#8E2F25]" data-testid="admin-login-error">{err}</p>}
          <button className="btn btn-primary w-full" disabled={busy} data-testid="admin-login-submit">{busy ? "Signing in…" : "Sign in"}</button>
          <Link to="/admin/forgot-password" className="block text-center text-sm text-forest underline-offset-4 hover:underline" data-testid="forgot-password-link">Forgot password?</Link>
        </div>
      </form>
    </main>
  );
}
